import "./style.css";
import "../../../styles/styleGlobal.css";

import { Helmet } from "react-helmet-async";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import bgImage from "./spr_background_game.png";
import { Space } from "antd";
import { AppStoreButton, GooglePlayButton } from "react-mobile-app-button";

function DBP56Page() {
  const [cookies, setCookie] = useCookies(["Lang"]);
  //   const [dataGame, setDataGame] = useState<GameType[]>(gamesVN);
  useEffect(() => {
    // if (cookies.Lang == null || cookies.Lang == undefined) {
    //   setCookie("Lang", 0);
    //   setDataGame(gamesVN);
    // } else setDataGame(cookies.Lang == 0 ? gamesVN : games);
  }, [cookies]);
  return (
    <div className={"game-page-container"}>
      <Helmet>
        <title>Battle of Dien Bien Phu | Pirex Games</title>
      </Helmet>
      <div
        className={"game-page-poster-bg"}
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >
        <div className={"game-page-poster-content non-selectable"}>
          <h1>
            Khói lửa chiến khu -<br></br> Ðiện Biên Phủ 56 ngày đêm
          </h1>
          <text>Lừng lẩy năm châu - chấn động địa cầu</text>
          <div className={"game-page-poster-button d-flex j-center alg-center"}>
            Xem Ngay
          </div>
          <br></br>
          <div className={"game-page-poster-store d-flex j-center alg-center"}>
            <GooglePlayButton
              url={""}
              theme={"dark"}
              className={"custom-style"}
            />
            <AppStoreButton
              url={""}
              theme={"dark"}
              className={"custom-style"}
            />
          </div>
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>

      <div className="game-page-description-content non-selectable">
        <h1>GIỚI THIỆU BỐI CẢNH LỊCH SỬ</h1>
        <text>
          Năm 1954, cuộc kháng chiến chống thực dân Pháp bước vào giai đoạn
          quyết định. Pháp xây dựng tập đoàn cứ điểm Điện Biên Phủ ở vùng Tây
          Bắc Việt Nam, với tham vọng biến nơi đây thành “pháo đài bất khả xâm
          phạm”, chặn đường tiến công của Quân đội Nhân dân Việt Nam và buộc ta
          phải đàm phán trong thế yếu. Tuy nhiên, dưới sự chỉ huy của Đại tướng
          Võ Nguyên Giáp, quân ta đã mở chiến dịch quy mô lớn với phương châm
          “đánh chắc, tiến chắc”. Hàng vạn chiến sĩ, dân công hỏa tuyến vượt núi
          rừng hiểm trở, kéo pháo, vận chuyển lương thực, đạn dược vào trận địa.
          Sau 56 ngày đêm chiến đấu anh dũng (từ 13/3 đến 7/5/1954), Quân đội
          Nhân dân Việt Nam đã đập tan toàn bộ tập đoàn cứ điểm Điện Biên Phủ,
          bắt sống toàn bộ tướng chỉ huy De Castries cùng hơn 16.000 quân địch.
          Chiến thắng Điện Biên Phủ “lừng lẫy năm châu, chấn động địa cầu”, buộc
          Pháp phải ký Hiệp định Genève, chấm dứt chiến tranh, mở đường cho nền
          độc lập và thống nhất đất nước.
        </text>
      </div>
      <div className="game-page-description-content non-selectable">
        <h1>GAME PLAY & CƠ CHẾ CHIẾN ĐẤU</h1>
        <text></text>
      </div>
    </div>
  );
}

export default DBP56Page;
